import _classPrivateFieldInitSpec from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Tuple } from "../base/Tuple.js";
/**
 * @name Range
 * @description
 * Rust `Range<T>` representation
 */

var _rangeName = /*#__PURE__*/new WeakMap();

export class Range extends Tuple {
  constructor(registry, Type, value) {
    let {
      rangeName = 'Range'
    } = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    super(registry, [Type, Type], value);

    _classPrivateFieldInitSpec(this, _rangeName, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldSet(this, _rangeName, rangeName);
  }

  static with(Type) {
    return class extends Range {
      constructor(registry, value) {
        super(registry, Type, value);
      }

    };
  }
  /**
   * @description Returns the starting range value
   */


  get start() {
    return this[0];
  }
  /**
   * @description Returns the ending range value
   */


  get end() {
    return this[1];
  }
  /**
   * @description Returns the base runtime type name for this instance
   */


  toRawType() {
    return `${_classPrivateFieldGet(this, _rangeName)}<${this.start.toRawType()}>`;
  }

}